var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/document copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000436313043 0.0599930435 22.845351 0.0599930435 22.845351 26.1787826 0.000436313043 26.1787826"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/document-copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.031117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7340321,0.117804522 L11.8070673,0.0610838261 L11.6565393,0.0599930435 L11.6139987,0.0599930435 L7.78753336,0.0599930435 L7.78753336,1.35038887 L7.78753336,5.19103443 C7.78753336,5.4375513 7.74172049,5.6764327 7.67518275,5.90986017 C7.60428188,6.15528626 7.50720223,6.38980452 7.36976362,6.6046887 C7.26723005,6.76394296 7.1516071,6.91556174 7.01525927,7.05190957 C6.5996711,7.46422539 6.0597337,7.71292383 5.48380049,7.78818783 L5.47180188,7.79146017 C5.3638144,7.80345878 5.2569177,7.82309287 5.14674866,7.82309287 L0.20004953,7.82309287 L0.000436313043,7.82309287 L0.000436313043,8.87133496 L0.000436313043,11.6375597 L0.000436313043,11.8295374 L0.000436313043,19.9078734 L0.000436313043,24.0157607 C0.000436313043,25.1807165 0.946144835,26.1209711 2.11219144,26.1209711 L5.48380049,26.1209711 L7.65554866,26.1209711 L11.9935911,26.1209711 L20.7340321,26.1787826 C21.8978972,26.1787826 22.8425149,25.2396188 22.8457873,24.0768445 L22.8457873,24.0724814 L22.8457873,19.9078734 L22.8457873,8.87133496 L22.8457873,2.22301496 C22.8425149,1.05696835 21.8978972,0.117804522 20.7340321,0.117804522 Z",
    id: "Fill-1",
    fill: "#999999",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.633744696,6.40652299 L4.75253983,6.40652299 C5.01214609,6.40652299 5.25429983,6.33889447 5.47136557,6.22763464 C5.4757287,6.2243623 5.47900104,6.21999917 5.48445496,6.2178176 C5.62734748,6.14364438 5.76151374,6.05420021 5.87495513,5.94075882 C6.15964939,5.65606456 6.33635617,5.26229203 6.33635617,4.82816056 L6.33635617,1.3823783 L6.33635617,0.721364035 C6.33635617,0.614467339 6.26981843,0.520660035 6.171648,0.479210296 C6.07238678,0.439942122 5.95894539,0.462848557 5.88477217,0.538112557 L5.48445496,0.936248209 L5.03723409,1.3823783 L0.446130087,5.95602977 C0.370866087,6.03238456 0.347959652,6.14582595 0.389409391,6.24508717 C0.429768348,6.34107603 0.526848,6.40652299 0.633744696,6.40652299",
    id: "Fill-4",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,12.5 C11.9101491,12.5 9,15.4101491 9,19 C9,22.5898509 11.9101491,25.5 15.5,25.5 C19.0898509,25.5 22,22.5898509 22,19 C21.996119,15.4117579 19.0882421,12.503881 15.5,12.5 Z M18.3166667,21.8280417 C18.1124898,22.044125 17.7736101,22.0589945 17.5512917,21.861625 L14.8651667,19.3992083 C14.7525175,19.2969886 14.6880411,19.1521131 14.6875,19 L14.6875,16.0208333 C14.6875,15.7216791 14.9300124,15.4791667 15.2291667,15.4791667 C15.5283209,15.4791667 15.7708333,15.7216791 15.7708333,16.0208333 L15.7708333,18.7616667 L18.2809167,21.0626667 C18.3873457,21.1594209 18.4509223,21.2945325 18.4576287,21.4382111 C18.464335,21.5818897 18.4136204,21.722336 18.3166667,21.8285833 L18.3166667,21.8280417 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPending);
export default __webpack_public_path__ + "static/media/documentPending.98d09175db1522157490d04ff1cac058.svg";
export { ForwardRef as ReactComponent };